import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'

class ClientSettingDetails extends React.Component {
  state = {
    support_email: '',
    support_phone: '',
    isData: false,
    loyalty_init: 0,
    loyalty_earn: 0,
    loyalty_redeem: 0,
    voucher_min_limit: 0,
    voucher_max_limit: 0,
    sign_up_reward: 0,
    sign_up_reward_expiry: 0,
  }

  componentDidMount() {
    this.getConstant()
  }
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }
  getConstant = async () => {
    await axios
      .get(Constant.getAPI() + `/client/get-client-settings`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          var Temp = [res?.data?.data]
          const matchItem = Temp?.filter((itm) => itm?.id === this.props?.match?.params?.id)

          if (matchItem?.length) {
            const itm = matchItem[0]
            this.setState({
              ...itm,
            })
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  addClientSetting = () => {
    var data = {
      id: this.props.match.params.id,
      support_email: this.state.support_email,
      support_phone: this.state.support_phone,
      loyalty_init: this.state.loyalty_init,
      loyalty_earn: this.state.loyalty_earn,
      loyalty_redeem: this.state.loyalty_redeem,
      voucher_min_limit: this.state.voucher_min_limit,
      voucher_max_limit: this.state.voucher_max_limit,
      sign_up_reward: this.state.sign_up_reward,
      sign_up_reward_expiry: this.state.sign_up_reward_expiry,
    }
    this.setState({ isData: true })

    axios
      .post(Constant.getAPI() + '/client/update-client-settings', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ isData: false })
        if (res.status) {
          Swal.fire({
            title: 'Client Setting Added Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        window.location.href = '#/client-setting'
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  onSaveData = () => {
    var that = this
    that.setState({ isSaving: true })

    that.addClientSetting()
  }
  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Edit Client Setting</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Edit Client Setting</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="">
                      {this.state.isloading ? (
                        'Loading ..!'
                      ) : (
                        <div className="card-body">
                          <div className="row">
                            <div className="col-12 col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Support Email</label>
                                <div className="col-sm-9">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="support_email"
                                    id="support_email"
                                    placeholder="Support email"
                                    onChange={this.handleChange}
                                    value={this.state.support_email}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Support Phone</label>
                                <div className="col-sm-9">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="support_phone"
                                    id="support_phone"
                                    placeholder="Support phone"
                                    onChange={this.handleChange}
                                    value={this.state.support_phone}
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-12"
                              style={{ borderTop: '1px solid #eee', marginBottom: 15 }}
                            ></div>
                            <div className="col-12 col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Initial Loyalty Points</label>
                                <div className="col-sm-9">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="loyalty_init"
                                    id="loyalty_init"
                                    placeholder="Initial Loyalty Points"
                                    onChange={this.handleChange}
                                    value={this.state.loyalty_init}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">
                                  Loyalty Points Earned Per Currency Unit
                                </label>
                                <div className="col-sm-9">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="loyalty_earn"
                                    id="loyalty_earn"
                                    placeholder="Loyalty Points Earned Per Currency Unit"
                                    onChange={this.handleChange}
                                    value={this.state.loyalty_earn}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">
                                  Currency Unit Redeemed Per Loyalty Point
                                </label>
                                <div className="col-sm-9">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="loyalty_redeem"
                                    id="loyalty_redeem"
                                    placeholder="Currency Unit Redeemed Per Loyalty Point"
                                    onChange={this.handleChange}
                                    value={this.state.loyalty_redeem}
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-12"
                              style={{ borderTop: '1px solid #eee', marginBottom: 15 }}
                            ></div>
                            <div className="col-12 col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Voucher min limit</label>
                                <div className="col-sm-9">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="voucher_min_limit"
                                    id="voucher_min_limit"
                                    placeholder="Voucher minimum amount"
                                    onChange={this.handleChange}
                                    value={this.state.voucher_min_limit}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Voucher max limit</label>
                                <div className="col-sm-9">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="voucher_max_limit"
                                    id="voucher_max_limit"
                                    placeholder="Voucher maximum amount"
                                    onChange={this.handleChange}
                                    value={this.state.voucher_max_limit}
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-12"
                              style={{ borderTop: '1px solid #eee', marginBottom: 15 }}
                            ></div>
                            <div className="col-12 col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Sign up reward amount</label>
                                <div className="col-sm-9">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="sign_up_reward"
                                    id="sign_up_reward"
                                    placeholder="Sign up reward amount"
                                    onChange={this.handleChange}
                                    value={this.state.sign_up_reward}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Sign up reward expiry(days)</label>
                                <div className="col-sm-9">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="sign_up_reward_expiry"
                                    id="sign_up_reward_expiry"
                                    placeholder="Sign up reward expiryin number of days"
                                    onChange={this.handleChange}
                                    value={this.state.sign_up_reward_expiry}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row float-right p-3">
                            {this.state.isData ? (
                              <button
                                className="btn btn-grd-disabled mr-2"
                                disabled
                              >
                                Saving...!
                              </button>
                            ) : (
                              <button
                                onClick={this.onSaveData}
                                className="btn btn-grd-disabled mr-2"
                              >
                                <i className="icofont icofont-save"></i> Save
                              </button>
                            )}
                            <Link
                              to={'/languages'}
                              className="btn btn-outline-dark"
                            >
                              Cancel
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ClientSettingDetails
